<template>
  <div class="offcanvas-body">
    <div class="h-100 d-flex flex-column justify-content-between">
      <div>
        <p class="text-subtitle mb-2">Seu gênero</p>
        <RadioInput :options="options" :model="genderModel" />
        <hr />
        <p class="text-subtitle mb-2">Gêneros que você atende</p>
        <RadioInput :options="acceptedGenderOptions" :model="acceptedGenderModel" />
      </div>
      <FormButton
        label="Concluir"
        :loading="submitting"
        @onClick="submit"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { genderSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useUpdateUser } from "@/composables/useAuth";

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const options = [
  { id: "female", name: "Feminino" },
  { id: "male", name: "Masculino" },
  { id: "other", name: "Outro" },
];

const acceptedGenderOptions = [
  { id: "all", name: "Todos os gêneros" },
  { id: "female", name: "Feminino" },
  { id: "male", name: "Masculino" },
];

const { handleSubmit, resetForm } = useForm({
  validationSchema: toTypedSchema(genderSchema),
  initialValues: { gender: "", accepted_gender: "all" },
});

const genderModel = useVeeField("gender");
const acceptedGenderModel = useVeeField("accepted_gender");

onMounted(() => {
  resetForm({
    values: {
      gender: session.value?.gender ?? "",
      accepted_gender: session.value?.accepted_gender ?? "all",
    },
  });
});

const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    await updateUser({
      id: session.value!.id,
      gender: values.gender as any,
      accepted_gender: values.accepted_gender as any,
    });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});
</script>
